import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {ResponseStatus} from "../../actions/types";
import fileService from "../../services/file-service";
import {handleGetMyUploads, onPaginationChange} from "../reducers/user-uploads.reducer";

export const getMyUploads = createAsyncThunk(
    'getMyUploads',
    async (props :{forceLoad?: boolean, page?: number}, thunkApi) => {
        try {
            const response = await fileService.getFiles(props.page || 0);
            return {myUploads: response && response.data}
        } catch (error) {
            return {
                access_token: null,
                errors: thunkApi.rejectWithValue(error)
            }
        }
    }
)

export const userUploadsSlice = createSlice({
    name: "userUploads",
    initialState: {
        myUploadsData: {
            files: [] as File[],
            currentPage: 0,
            pageSize: 10,
            totalItems: 0,
        } ,
        errors: [],
        isLoading: false,
    } as UserUploadsSliceData,
    reducers: {
        changePagination: onPaginationChange
    },
    extraReducers: (builder) => {
        builder.addCase(getMyUploads.pending, state => handleGetMyUploads(state, ResponseStatus.PENDING, null));
        builder.addCase(getMyUploads.fulfilled, (state, action) => handleGetMyUploads(state, ResponseStatus.SUCCESS, action.payload));
        builder.addCase(getMyUploads.rejected, (state, action) => handleGetMyUploads(state, ResponseStatus.FAIL, action.payload));
    }
})

export interface UserUploadsSliceData {
    myUploadsData: {
        files: File[],
        currentPage: number,
        pageSize: number,
        totalItems: number,
    },
    errors: any[],
    isLoading: boolean,
}

export default userUploadsSlice.reducer;
export const {changePagination} = userUploadsSlice.actions;
